import { graphql } from 'gatsby';
import { getKey } from '../../../helpers';

/**
 * Hero widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the props
 * @returns {Object} widget definition
 */
export default function hero (props, locale) {
  return {
    widgetType: 'hero',
    key: getKey(props, 'key'),
    title: getKey(props, `title_${locale}`),
    description: getKey(props, `description_${locale}`),
    textCall: getKey(props, `textCall_${locale}`),
    urlCall: getKey(props, `urlCall_${locale}`),
    image: {
      small: getKey(props, 'image.small.url'),
      medium: getKey(props, 'image.medium.url'),
      large: getKey(props, 'image.large.url')
    },
    fluid: getKey(props, 'image.large.childImageSharp.fluid')
  };
}

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Hero on StrapiWidgetrels {
    hero {
      key: id
      title_en
      title_es
      description_es
      description_en
      textCall_en
      textCall_es
      urlCall_en
      urlCall_es
      urlCall
      image {
        large {
          childImageSharp {
            fluid(maxWidth: 1200, maxHeight: 650) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      widgetPosition
    }
  }
`;
